export default "__VITE_ASSET__TttsnXp6__"